require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./label"), require("./backbutton"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./label", "./backbutton"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./label"), require("./backbutton")) : factory(root["./utils"], root["./label"], root["./backbutton"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__58__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[6],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(227);


/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Breadcrumb = _interopRequireDefault(__webpack_require__(228));

exports.default = _Breadcrumb.default;
exports.Breadcrumb = _Breadcrumb.default;

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _backbutton = _interopRequireDefault(__webpack_require__(58));

var _utils = __webpack_require__(5);

var _folderOverflow_ = _interopRequireDefault(__webpack_require__(229));

var _baUiCarbon = __webpack_require__(9);

var _label = _interopRequireDefault(__webpack_require__(17));

var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(230));

var _BreadcrumbItem2 = _interopRequireDefault(__webpack_require__(231));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const breadcrumbItemClassName = _BreadcrumbItem2.default.breadcrumbItemClassName.replace(/"/g, '');

const {
  BaPropTypes
} = _utils.propsUtils;

class Breadcrumb extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_onBackButtonClick", () => {
      this.props.historyCallback();
    });
    (0, _defineProperty2.default)(this, "_onBreadCrumbClick", (currentNode, id) => {
      !currentNode && this.props.navCallback && this.props.navCallback(id);
    });
  }

  onKeyUp(evt, callback, currentNode, id) {
    if (evt.type === 'click' && !evt.shiftKey && !evt.ctrlKey && evt.nativeEvent.which !== 3 || evt.type === 'keyup' && evt.keyCode === 13) {
      callback(currentNode, id);
    }
  }
  /*
   * CALLBACKS
   */


  render() {
    const {
      ancestors,
      hideBackButton,
      className,
      style,
      textDir,
      noTrailingSlash,
      hideCurrentNode
    } = this.props; // show/hide back button node

    const backButtonNode = !hideBackButton && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_backbutton.default, {
      buttonType: "nav_pane",
      onClick: this._onBackButtonClick,
      onKeyUp: evt => this.onKeyUp(evt, this._onBackButtonClick)
    })); // create crumb item nodes


    const crumbNodes = ancestors.map((currVal, index, ancestorsArr) => {
      const isValue = !!currVal.defaultName;
      const currentNode = index === ancestorsArr.length - 1;
      const hideNode = hideCurrentNode && currentNode && index !== 0;
      let breadcrumb;

      if (isValue && !hideNode) {
        breadcrumb = /*#__PURE__*/_react.default.createElement(_BreadcrumbItem.default, {
          tabIndex: 0,
          key: index,
          className: breadcrumbItemClassName,
          isCurrentPage: currentNode,
          onClick: () => this._onBreadCrumbClick(currentNode, index),
          onKeyUp: evt => this.onKeyUp(evt, this._onBreadCrumbClick, currentNode, index)
        }, /*#__PURE__*/_react.default.createElement(_label.default, {
          style: {
            userSelect: 'all'
          },
          label: currVal.defaultName,
          ellipsis: true,
          location: currentNode ? 'end' : 'middle',
          textDir: textDir
        }));
      }

      return breadcrumb;
    });
    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.Breadcrumb, {
      className: className,
      style: style,
      noTrailingSlash: noTrailingSlash
    }, backButtonNode, crumbNodes);
  }

}

exports.default = Breadcrumb;
(0, _defineProperty2.default)(Breadcrumb, "propTypes", {
  /** Pass an array of js objects that detail the ancestors of the current crumb node. The minimum requirements are an id, a defaultName and an icon */
  ancestors: _propTypes.default.array,

  /** pass a callback function that defines the behaviour when clicking on a crumb node */
  navCallback: _propTypes.default.func,

  /** Pass a callback function that defines the behaviour of clicking the back button */
  historyCallback: _propTypes.default.func,

  /** Pass a custom icon for the context menu. Default icon is folder-overflow_16 */
  // eslint-disable-next-line react/no-unused-prop-types
  menuIcon: BaPropTypes.deprecated('is ignored and not applicable to carbon breadcrumb'),

  /** String value to display different font-sizes Options: small, medium(default), large */
  // eslint-disable-next-line react/no-unused-prop-types
  size: BaPropTypes.deprecated('is ignored and not applicable to carbon breadcrumb'),

  /** Boolean value to hide the back button */
  hideBackButton: _propTypes.default.bool,

  /** Custom class name(s) */
  className: _propTypes.default.string,

  /** Custom css styles */
  style: _propTypes.default.object,

  /** text direction */
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),

  /** Optional prop to omit the trailing slash for the breadcrumbs */
  noTrailingSlash: _propTypes.default.bool,

  /** Option to omit the current page node from the breadcrumb */
  hideCurrentNode: _propTypes.default.bool
});
(0, _defineProperty2.default)(Breadcrumb, "defaultProps", {
  ancestors: [],
  menuIcon: _folderOverflow_.default,
  size: 'medium',
  hideBackButton: true,
  className: '',
  style: {},
  noTrailingSlash: false,
  hideCurrentNode: false
});

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/folder-overflow_16.js");

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _baUiCarbon = __webpack_require__(9);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
class BreadcrumbItem extends _react.Component {
  render() {
    const {
      isCurrentPage,
      ...other
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.BreadcrumbItem, (0, _extends2.default)({
      isCurrentPage: isCurrentPage
    }, other));
  }

}

exports.default = BreadcrumbItem;
(0, _defineProperty2.default)(BreadcrumbItem, "propTypes", {
  /** Provide if this breadcrumb item represents the current page */
  isCurrentPage: _propTypes.default.node
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_BreadcrumbItem_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_BreadcrumbItem_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_BreadcrumbItem_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_BreadcrumbItem_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_BreadcrumbItem_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__58__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-breadcrumbItem .ba-common-label{color:#0f62fe}", ""]);

// exports
exports.locals = {
	"breadcrumbItemClassName": "\"ba-common-breadcrumbItem\""
};

/***/ })

},[[226,0]]]);
});